const features = [
  {
    icon: 'ri-scroll-to-bottom-line',
    title: '下拉式滚动阅读',
    desc: '创新的连续滚动阅读模式，无需手动翻页，向下滑动即可无缝加载后续章节，提供如丝般顺滑的沉浸式追漫体验。',
    color: 'primary',
  },
  {
    icon: 'ri-global-line',
    title: '海量免费漫画资源',
    desc: '收录超过50,000部日漫、韩漫、国漫作品，从经典老番到最新连载一应俱全，全部免费在线阅读，无需注册即可畅享。',
    color: 'accent',
  },
  {
    icon: 'ri-flashlight-line',
    title: '每日稳定高速更新',
    desc: '日更200+章节，热门连载与官方同步，第一时间送达最新话。智能推送系统让你不错过任何一部追更中的漫画更新。',
    color: 'secondary',
  },
  {
    icon: 'ri-device-line',
    title: '多端适配随时畅读',
    desc: '网页端、移动端全面适配，无论电脑、平板还是手机都能获得最佳阅读体验。支持夜间模式和字号调节，保护你的双眼。',
    color: 'primary',
  },
];

const colorMap: Record<string, { iconBg: string; iconText: string; accentBg: string }> = {
  primary: { iconBg: 'bg-primary-100', iconText: 'text-primary-500', accentBg: 'bg-primary-100/70' },
  accent: { iconBg: 'bg-accent-100', iconText: 'text-accent-500', accentBg: 'bg-accent-100/70' },
  secondary: { iconBg: 'bg-secondary-100', iconText: 'text-secondary-500', accentBg: 'bg-secondary-100/70' },
};

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          为什么选择酷漫屋
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          四大核心优势，打造极致的免费漫画在线阅读体验
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {features.map((item) => {
            const c = colorMap[item.color];
            return (
              <div
                key={item.title}
                className="group bg-background-50 rounded-2xl border border-background-200/80 p-5 md:p-6 cursor-pointer transition-transform hover:-translate-y-1"
              >
                <div className={`w-12 h-12 rounded-xl ${c.iconBg} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                  <i className={`${item.icon} ${c.iconText} text-xl`}></i>
                </div>
                <h3 className="text-sm md:text-base font-medium text-foreground-800 mb-2">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}